import {z} from 'zod'

import {validateName, validatePhoneNumber} from '../common/validation/validateContact'

import {SiteContactForm} from './types'

export const validateSiteContact = (data: SiteContactForm, ctx: z.RefinementCtx) => {
  const {siteContact} = data
  if (!siteContact) {
    // If siteContact is missing entirely, add validation error
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['siteContact'],
      message: 'Site contact information is required'
    })
    return
  }
  validatePhoneNumber(ctx, 'siteContact', siteContact.phoneNumber)
  validateName(ctx, 'siteContact', siteContact.name)
}
